// extracted by mini-css-extract-plugin
module.exports = {"header":"tags_header__1Y2TR","page_dis":"tags_page_dis__bLiDo"};